var path = '/modules/messages/views/pages/sms/templates/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/messages/views/pages/sms/templates/list.tpl.html
// module id = 2144
// module chunks = 1